import { DefaultOptionType } from "antd/es/select";
import { DataPair } from "../../types";

export interface Tracking {
  tipPakovanja: string;
  tipPakovanjaId: number | null;
  idKod: string;
  nazivDrustva: string;
  napomena: string;
  voziloSlanje: string;
  pretovar: string;
  objekat: string;
  drustvoSlanje: string;
  objekatSlanje: string;
  boks: string;
  paleta: string;
  otpremnica: boolean;
  masterCase: string;
  status: string;
  datum: string;
  zbirnoPakovanje?: string;
  pib: string;
  id: number | null;
  nested?: boolean;
  customId?: number | null;
  children?: Tracking[];
}

export interface TrackingListFilterPayload {
  tip: number | null;
  pib: string | null;
  kod: string | null;
  status: number | null;
  pageNumber: number | null;
  pageSize: number | null;
}

export interface TrackingListResponse {
  list: Array<Tracking>;
  total: number;
}

export interface ITtIstorijaKodaPayload {
  pib: string | null;
  kod: string | null;
}

export interface ISastavPakovanjaIstorija {
  id: number;
  tipPakovanjaId: number | null;
}

export interface IBrendDetaljiTTKod {
  brendNaziv: string;
  brendSifra: string;
  brojCigaretaUPojedinacnomPakovanju: number;
  serijskiBrojMasine: string | null;
  modelMasine: string | null;
  proizvodjacMasina: string | null;
  pakovanjeTip: string | null;
  kolicina: number | null;
}

export interface ITtKodDetalji {
  brendDetalji: IBrendDetaljiTTKod[];
  vozilo: string | null;
  brojOtpremnice: string | null;
  statusOtpremnice: string | null;
  napomena: string | null;
  pretovar: string | null;
  planiranoVremeIsporuke: string | null;
}

export interface IRobneMarkePretragaProps {
  id: number | null;
  naziv: string;
}

export interface TrackingListFiltersData {
  tipPakovanja: DataPair[];
  status: DataPair[];
}

export interface TrackingListFiltersDataResponse {
  statuses: DefaultOptionType[];
  packageTypes: DefaultOptionType[];
}

export interface TrackAndTraceState {
  //Response for inicijalnaTabelaZaPracenje

  pracenjeTabela: Tracking[];

  //Response for inicijalniPodaciZaPracenje

  tipPakovanja: DataPair[];
  statusFilter: DataPair[];
}

export type UpdateTrackAndTraceFunction = (
  updatedState: Partial<TrackAndTraceState>
) => void;

export interface Monitoring {
  id: number;
  drustvoPIB: string;
  drustvoNaziv: string;
  adresaOtpreme: string;
  drustvoSlanjePIB: string;
  drustvoSlanjeNaziv: string;
  adresaOdredista: string;
  brojOtpremnice: string;
  slanjeId: number;
  monitoringActionNaziv: string;
}
export interface MonitoringListFilterPayload {
  drustvoPIB: string | null;
  drustvoSlanjePIB: string | null;
  brojOtpremnice: string | null;
  pageNumber: number | null;
  pageSize: number | null;
}

export interface MonitoringListResponse {
  list: Array<Monitoring>;
  total: number;
}

export interface MonitoringDetails {
  tipPakovanjaNaziv: string;
  robnaMarkaNaziv: string;
  kolicina: number;
}

export interface MonitoringDetailsResponse {
  slanje: {
    slanjeId: number;
    listaZaSlanje: Array<MonitoringDetails>;
    planiranoVremeIsporuke: string | null;
  };
  prijem: {
    brojOtpremnice: string;
    listaKvantitativnogPrijema: Array<MonitoringDetails>;
    planiranoVremeOtpreme: string | null;
    vremeFizickogPrijema: string | null;
  };
  isPrijem?: boolean;
}

export enum IzvestajiOPrometuTab {
  PROIZVODNJA = "proizvodnja",
  UVOZ = "uvoz",
  VELETRGOVINA = "veletrgovina",
}

export interface IzvestajiOPrometuUvoz {
  id: number;
  pib: string;
  poslato: number;
  primljeno: number;
  unisteno: number;
  ukupnaKolicina: number;
  stanjeNaZalihama: number;
  nazivDrustva: string;
}

export interface IzvestajiOPrometuProizvodnja {
  id: number;
  nazivDrustva: string;
  pib: string;
  poslato: number;
  primljeno: number;
  unisteno: number;
  ukupnaKolicina: number;
  stanjeNaZalihama: number;
}

export interface IzvestajiOPrometuVeletrgovina {
  id: number;
  ime: string;
  pib: string;
  nazivMaloprodaje: string;
  pibMaloprodaje: string;
  poslato: number;
  primljeno: number;
  unisteno: number;
  ukupnaKolicina: number;
  stanjeNaZalihama: number;
}

export interface IzvestajiOPrometu {
  uvoz: Array<IzvestajiOPrometuUvoz>;
  proizvodnja: Array<IzvestajiOPrometuProizvodnja>;
  veletrgovina: Array<IzvestajiOPrometuVeletrgovina>;
  period: Array<{ id: number; naziv: string }>;
  periodId: number | null;
  totalCount: number;
}

export interface IzvestajiOPrometuPayload {
  periodId: number | null;
  pib: string | null;
  pibMaloprodaje: string | null;
  pageNumber: number | null;
  pageSize: number | null;
}
